import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let WhiteBox = class WhiteBox extends Vue {
};
WhiteBox = __decorate([
    Component({
        data() {
            return {};
        },
        created() {
            // 
        },
    })
], WhiteBox);
export default WhiteBox;
